import { render } from "./clientCollections.vue?vue&type=template&id=3209b8de&scoped=true"
import script from "./clientCollections.vue?vue&type=script&lang=js"
export * from "./clientCollections.vue?vue&type=script&lang=js"

import "./clientCollections.vue?vue&type=style&index=0&id=3209b8de&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/fundraise/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3209b8de"]])

export default __exports__